import React from 'react';
import classNames from 'classnames';
import AbstractReactComponent from './../AbstractReactComponent';
import {connect} from 'react-redux'
import {Pagination, PaginationItem, PaginationLink} from 'reactstrap';
import {storeFromArea} from "./../utils";
import * as PagingActions from "./paging/PagingActions"

class AdvancedPagination extends AbstractReactComponent {

    static propTypes = {
        area: React.PropTypes.string.isRequired,    // area pagging! NE seznamu!!!
        paging: React.PropTypes.object,  // store na paging, nastavuje se dle area v této komponentě
        center: React.PropTypes.bool, // Centrovani tlacitek
        autoHide: React.PropTypes.bool, // Skryt pokud neni potreba strankovat

    };

    static defaultProps = {
        center: true,
        autoHide: true,
    };

    handleSelect(pageIndex){
        const {area} = this.props;
        this.props.dispatch(PagingActions.goToPage(area, pageIndex));
    }

    handleSelectFirst = () => {
        this.handleSelect(0);
    };

    handleSelectPrev = () => {
        const {paging: {pageIndex}} = this.props;
        this.handleSelect(pageIndex - 1);
    };

    handleSelectNext = () => {
        const {paging: {pageIndex}} = this.props;
        this.handleSelect(pageIndex + 1);
    };

    handleSelectLast = () => {
        const {paging: {pagesCount}} = this.props;
        this.handleSelect(pagesCount - 1);
    };

    renderButton(label, disabled, onClick, key) {
        return (
            <PaginationItem disabled={disabled} key={key}>
                <PaginationLink href="#" onClick={onClick}>{label}</PaginationLink>
            </PaginationItem>
        );
    }

    renderPageButton(page, activePage) {
        const disabled = page === activePage;
        const onClick = () => this.handleSelect(page - 1);
        return this.renderButton(page, disabled, onClick, page);
    }

    renderEllipsis(key) {
        return this.renderButton('\u2026', true, null, key);
    }

    renderPageButtons() {
        const {paging: {pagesCount, pageIndex}} = this.props;

        const maxButtons = 5;
        const activePage = pageIndex + 1;
        const pageButtons = [];

        let startPage;
        let endPage;

        if (maxButtons < pagesCount) {
            startPage = Math.max(
                Math.min(
                    activePage - Math.floor(maxButtons / 2, 10),
                    pagesCount - maxButtons + 1,
                ),
                1,
            );
            endPage = startPage + maxButtons - 1;
        } else {
            startPage = 1;
            endPage = pagesCount;
        }

        for (let page = startPage; page <= endPage; ++page) {
            pageButtons.push(this.renderPageButton(page, activePage));
        }

        if (startPage > 1) {
            if (startPage > 2) {
                pageButtons.unshift(this.renderEllipsis('elps1'));
            }
            pageButtons.unshift(this.renderPageButton(1, activePage));
        }

        if (endPage < pagesCount) {
            if (endPage < pagesCount - 1) {
                pageButtons.push(this.renderEllipsis('elps2'));
            }
            pageButtons.push(this.renderPageButton(pagesCount, activePage));
        }

        return pageButtons;
    }

    render() {
        const {
            paging: {pagesCount, pageIndex},
            center,
            area,
            dispatch,
            autoHide,
            ...otherProps
        } = this.props;

        const isFirstPage = pageIndex == 0;
        const isLastPage = pageIndex >= pagesCount - 1;
        const invisible = pagesCount <= 1;

        return (
            <Pagination className={classNames({invisible, 'justify-content-center': center})} {...otherProps}>
                {this.renderButton('\u00ab', isFirstPage, this.handleSelectFirst)}
                {this.renderButton('\u2039', isFirstPage, this.handleSelectPrev)}
                {this.renderPageButtons()}
                {this.renderButton('\u203a', isLastPage, this.handleSelectNext)}
                {this.renderButton('\u00bb', isLastPage, this.handleSelectLast)}
            </Pagination>
        );
    }
}

function mapStateToProps(state, props) {
    return {
        paging: storeFromArea(state, props.area),
    };
}

export default connect(mapStateToProps)(AdvancedPagination);
